const ImagesMovieDisplayAndUploadFieldPosition = ({fieldName, fieldValue, setFieldValue, className = '', orientation = "horizontal"}) => (
    <div className={"slidecontainer " + className}>
        <input
            type="range" 
            step="1" 
            min="0" 
            max="100" 
            orient={orientation}
            className={"text-regular range-slider input-text-box"}
            value={fieldValue}
            onChange={(event) => {
                setFieldValue(fieldName, parseInt(event.target.value))
            }}
        />
    </div>
)

export default ImagesMovieDisplayAndUploadFieldPosition